import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { APP_VERSION } from "@/version";

// Public page (/frontendversion) to verify the deployed build. Shows the frontend bundle version
// and, best-effort, the backend version fetched from /api/version, so both can be checked at once.
export default function FrontendVersion() {
  const [backend, setBackend] = useState("…");
  useEffect(() => {
    api.get("/version")
      .then((r) => setBackend(r.data?.version || "unknown"))
      .catch(() => setBackend("unreachable"));
  }, []);
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-6 font-mono text-zinc-100"
      data-testid="frontend-version-page">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <img src="/logo.svg" alt="" className="h-8 w-8" />
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-zinc-400">Scalio Nexus</span>
        </div>
        <dl className="space-y-3 rounded-sm border border-zinc-800 bg-zinc-900 p-5">
          <div className="flex items-center justify-between gap-6">
            <dt className="text-xs uppercase tracking-wider text-zinc-500">Frontend</dt>
            <dd className="text-lg font-bold text-emerald-400" data-testid="frontend-version-value">{APP_VERSION}</dd>
          </div>
          <div className="h-px bg-zinc-800" />
          <div className="flex items-center justify-between gap-6">
            <dt className="text-xs uppercase tracking-wider text-zinc-500">Backend</dt>
            <dd className="text-lg font-bold text-sky-400" data-testid="backend-version-value">{backend}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
